import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// export default vConsole
// window.console.log = function () { };

// 部分推送/通知链接由后端拼接时会带上多余的斜杠（如 #///contractor-work/approval?taskId=xxx），
// Angular Router 的 pathMatch: 'full' 按 URL 段严格匹配，多余的空段会导致匹配失败、taskId 丢失。
// 在 Router 读取 URL 之前先把 hash 路径中的连续斜杠合并成一个。
(function normalizeHashSlashes() {
  const hash = window.location.hash;
  if (!hash) {
    return;
  }
  const rest = hash.slice(1); // path?query
  const qIndex = rest.indexOf('?');
  const path = qIndex === -1 ? rest : rest.slice(0, qIndex);
  const query = qIndex === -1 ? '' : rest.slice(qIndex);
  const normalizedPath = path.replace(/\/{2,}/g, '/');
  if (normalizedPath !== path) {
    const normalizedHash = '#' + normalizedPath + query;
    history.replaceState(null, '', window.location.pathname + window.location.search + normalizedHash);
  }
})();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));

// window.alert = function () {
//   return false;
// }
// window.console.log = function() {};
